import { jsx as _jsx } from "react/jsx-runtime";
import { Prompt } from "@coveord/plasma-mantine";
import { Locales } from "../../../strings/Locales";
export var DeleteSingleResourcePromptCancelButton = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Prompt.CancelButton, {
        onClick: onClick,
        children: Locales.format("DeleteSingleResourcePrompt.footer.button.cancel")
    });
};

//# sourceMappingURL=DeleteSingleResourcePromptCancelButton.js.map